module.exports = __webpack_public_path__ + "static/img/index.5932353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/991B/index.png
// module id = pQZU
// module chunks = 0